import { CustomElement } from "./types";

export const EMPTY_NODE: CustomElement = {
  type: "paragraph",
  children: [{ text: "" }]
};
export const DEFAULT_VALUE = '[{"type":"paragraph","children":[{"text":""}]}]';
